import ui from './ui.json'

export default {
  language: 'English',
  languageTag: 'en',
  ...ui
}
